class StickyAtcContainer extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const target = document.querySelector('product-info .product-form__submit');
        const triggerSection = this.findCustomerSection();
        const footer = document.querySelector('.shopify-section-group-footer-group, footer, .u-footer_background');
        let hasReachedTrigger = false;
        let isAtFooter = false;
        let footerCheckFrame = null;

        const updateVisibility = () => {
            if (hasReachedTrigger && !isAtFooter) {
                this.classList.remove('hidden');
            } else {
                this.classList.add('hidden');
            }
        };

        const getStickyBoundaryHeight = () => {
            if (this.offsetHeight > 0) return this.offsetHeight;

            return window.matchMedia('(min-width: 768px)').matches ? 174 : 96;
        };

        const checkFooterBoundary = () => {
            footerCheckFrame = null;

            if (!footer) {
                isAtFooter = false;
                updateVisibility();
                return;
            }

            const footerTop = footer.getBoundingClientRect().top;
            const stickyHeight = getStickyBoundaryHeight();
            isAtFooter = footerTop <= window.innerHeight - stickyHeight - 8;
            updateVisibility();
        };

        const requestFooterBoundaryCheck = () => {
            if (footerCheckFrame) return;
            footerCheckFrame = window.requestAnimationFrame(checkFooterBoundary);
        };

        const checkTriggerBoundary = () => {
            if (!triggerSection) return;

            const triggerTop = triggerSection.getBoundingClientRect().top;
            hasReachedTrigger = triggerTop <= window.innerHeight;
            requestFooterBoundaryCheck();
        };

        if (triggerSection) {
            checkTriggerBoundary();
            window.addEventListener('scroll', checkTriggerBoundary, { passive: true });
            window.addEventListener('resize', checkTriggerBoundary);
        } else if (target) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    hasReachedTrigger = !entry.isIntersecting && window.scrollY > target.offsetTop;
                    requestFooterBoundaryCheck();
                });
            });
            observer.observe(target);
        }

        if (!target) {
            hasReachedTrigger = !triggerSection;
            checkFooterBoundary();
            window.addEventListener('scroll', requestFooterBoundaryCheck, { passive: true });
            window.addEventListener('resize', requestFooterBoundaryCheck);
            return;
        }
        checkFooterBoundary();

        if (footer) {
            window.addEventListener('scroll', requestFooterBoundaryCheck, { passive: true });
            window.addEventListener('resize', requestFooterBoundaryCheck);
        }


        document.addEventListener('DOMContentLoaded', () => {
            this.querySelector('.close-icon').addEventListener('click', () => {
                document.querySelector('sticky-atc-container').remove();
            })
            this.querySelector('.product-variant-id').addEventListener('change', (event) => {
                let selectedPrice = event.target.querySelector('option[value="'+event.target.value+'"]').getAttribute('data-price');
                this.querySelector('.atc-product-price-element .amount').textContent = selectedPrice;
                if (event.target.querySelector('option[value="'+event.target.value+'"]').getAttribute('data-compare-at-price')) {
                    this.querySelector('.atc-product-price-strikethrough').textContent = event.target.querySelector('option[value="'+event.target.value+'"]').getAttribute('data-compare-at-price');
                } else {
                    this.querySelector('.atc-product-price-strikethrough').textContent = '';
                }
                if(this.querySelector('[data-discount-controller-variant]')) {
                    this.querySelector('[data-discount-controller-variant]').setAttribute('data-discount-controller-variant', event.target.value);
                }
            });
            this.querySelector('.product-variant-id').dispatchEvent(new CustomEvent('change'));
        })
    }

    findCustomerSection() {
        const candidates = document.querySelectorAll('main .shopify-section, main section, main [id]');

        return Array.from(candidates).find((candidate) => {
            if (candidate.contains(this)) return false;

            const text = (candidate.textContent || '').toLowerCase();
            return text.includes('200.000') && text.includes('zufriedene') && text.includes('kunden');
        }) || null;
    }

}
customElements.define('sticky-atc-container', StickyAtcContainer);
